import { positionSide, type WidgetPosition } from '../position'
import { FAB_CLOSE_PATH, resolveFabIconPath } from './fab-icons'

function createSvg(path: string): SVGSVGElement {
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
  svg.setAttribute('viewBox', '0 0 24 24')
  const p = document.createElementNS('http://www.w3.org/2000/svg', 'path')
  p.setAttribute('d', path)
  svg.appendChild(p)
  return svg
}

export function createFab(
  position: WidgetPosition,
  onClick: () => void,
  label?: string,
  fabIcon?: string,
): HTMLButtonElement {
  const btn = document.createElement('button')
  const side = positionSide(position)
  btn.className = `rqd-fab rqd-${position} rqd-fab-labeled rqd-fab-side-${side}`
  btn.appendChild(createSvg(resolveFabIconPath(fabIcon)))
  const accessibleLabel = label ?? 'Open support widget'
  if (label) {
    const span = document.createElement('span')
    span.className = 'rqd-fab-label'
    span.setAttribute('aria-hidden', 'true')
    span.textContent = label
    btn.appendChild(span)
  }
  btn.setAttribute('aria-label', accessibleLabel)
  btn.addEventListener('click', onClick)
  return btn
}

export function setFabOpen(fab: HTMLButtonElement, isOpen: boolean, label?: string, fabIcon?: string): void {
  while (fab.firstChild) fab.removeChild(fab.firstChild)
  fab.appendChild(createSvg(isOpen ? FAB_CLOSE_PATH : resolveFabIconPath(fabIcon)))
  if (isOpen) {
    fab.classList.remove('rqd-fab-labeled', 'rqd-fab-side-start', 'rqd-fab-side-end')
    fab.setAttribute('aria-label', 'Close support widget')
  } else {
    // Re-add pill state. Caller passes the current position-derived side class on re-open.
    fab.classList.add('rqd-fab-labeled')
    if (label) {
      const span = document.createElement('span')
      span.className = 'rqd-fab-label'
      span.setAttribute('aria-hidden', 'true')
      span.textContent = label
      fab.appendChild(span)
    }
    fab.setAttribute('aria-label', label ?? 'Open support widget')
  }
}
